import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosRequestConfig } from 'axios';
import { BasicStateTypes } from '../types/types';
import { PUBLIC_BASE_URL, HEADERS } from '../utils/config';

const initialState: BasicStateTypes = {
  loading: false,
  data: null,
  error: null,
};

export const getFrontViewData = createAsyncThunk(
  'frontView/getFrontViewData',
  async ({ method, data }: { method: string, data: any }, { rejectWithValue }) => {
    const url = `${PUBLIC_BASE_URL}/home`
    try {
      const config: AxiosRequestConfig = {
        method,
        url,
        headers: await HEADERS(),
        data,
      };
      const response = await axios(config);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const frontViewSlice = createSlice({
  name: 'frontView',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFrontViewData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFrontViewData.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getFrontViewData.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default frontViewSlice.reducer;
